import { Component, Input, ViewChild, OnInit, OnDestroy } from "@angular/core";

import * as _ from "lodash";
import { Subscription } from "rxjs";

import { Table } from "../../classes/table";

import { FormSchemaData, InputComponent } from "../../../form/index";

import { TablePaginationSize } from "../../table.interface";

@Component({
  selector: "uex-table-footer",
  templateUrl: "./footer.component.html",
  host: {
    class: "uex-table-footer"
  }
})
export class TableFooterComponent implements OnInit, OnDestroy {
  @ViewChild("pageNumberInput", { static: false })
  pageNumberInput: InputComponent;
  @Input() table: Table;

  constructor() {}

  public page_number_schema: FormSchemaData;
  public page_size_schema: FormSchemaData;

  private _data_subscription: Subscription;
  private _data_length = 0;

  public ngOnInit() {
    this.page_number_schema = {
      key: "page_number",
      label: "PÃ¡gina",
      type: "number",
      value: this.page_number,
      events: {
        onBlur: event => {
          this.page_number = event.schema.value;
        },
        onKeypress: event => {
          const keyCode = event.eventRef.which || event.eventRef.keyCode;
          if (keyCode == 13) {
            this.page_number = event.schema.value;
          }
        }
      },
      validations: {
        min: 0,
        max: 9999
      }
    };

    this.page_size_schema = {
      key: "page_size",
      label: "Exibir",
      type: "select",
      value: this.page_size,
      options: [
        { value: 5, label: 5 },
        { value: 10, label: 10 },
        { value: 15, label: 15 },
        { value: 25, label: 25 },
        { value: 50, label: 50 },
        { value: 100, label: 100 },
        { value: 150, label: 150 }
      ],
      events: {
        onChange: event => {
          this.page_size = <TablePaginationSize>parseInt(event.schema.value);
          this.table.update();
        }
      },
      validations: {
        min: 0,
        max: 9999
      }
    };

    this.table.onDataChange.subscribe(() => {
      if (this.pageNumberInput) {
        this.pageNumberInput.schema.value = this.page_number;
      }
    });

    this._updateDataLength();
    this._data_subscription = this.table.onDataChange.subscribe(() =>
      this._updateDataLength()
    );
  }

  public ngOnDestroy() {
    if (this._data_subscription) {
      this._data_subscription.unsubscribe();
    }
  }

  public get page_size(): TablePaginationSize {
    return this.table.pagination.size;
  }

  public set page_size(size: TablePaginationSize) {
    this.table.setPageSize(size);
  }

  public get page_number(): number {
    return this.table.pagination.number;
  }

  public set page_number(number: number) {
    this.table.setPageNumber(number);
  }

  public getCountAll(): number {
    return this.table.remote.valid || this.table.pagination.manual
      ? this.table.pagination.count
      : this.table.getRawData().length;
  }

  public getStartIndex(): number {
    return this._data_length > 0
      ? (this.table.pagination.number - 1) * this.table.pagination.size + 1
      : 0;
  }

  public getEndIndex(): number {
    return this._data_length > 0
      ? this.getStartIndex() + (this._data_length - 1)
      : 0;
  }

  public allowDecreasePage(): boolean {
    return this.table.pagination.number > 1;
  }

  public allowIncreasePage(): boolean {
    return this.table.pagination.number < this.table.pagination.last;
  }

  public decreasePage() {
    this.table.decreasePage();
  }

  public increasePage() {
    this.table.increasePage();
  }

  private _updateDataLength() {
    this._data_length = this.table.getData().length;
  }
}
